import { render, staticRenderFns } from "./CreateSeafarerProfile.vue?vue&type=template&id=468b1746"
import script from "./CreateSeafarerProfile.vue?vue&type=script&lang=ts"
export * from "./CreateSeafarerProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports